import React, { useState,useCallback,useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import { useParams } from 'react-router';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step  from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { StepIconProps } from '@mui/material/StepIcon';
import SetaButton from './Images/SetaButton.png'
import { readDataStorage,writeStorage} from "../../utils/storage/storage";
import api from "../../services/api"
import { ContainerSection, StepperStyleDesktop,ButtonStep, StepperStyleLabel} from './styled';
import { useProgress } from "../../hooks/progress";
import Holderdata from './HolderSteps/Holderdata';
import HolderConfirmation from './HolderSteps/HolderConfirmation';
import GridGrafico from './GridGrafico/GridGrafico.js';
import UserConsumption from './UserConsumption';
import getStateAbbreviation from './HolderSteps/StateAbbreviation';
import ValueChangeWatcher from './ValueChangeWatcher';

const steps = [
  'Confirme seu consumo',
  'Detalhes da economia',
  'Unidade consumidora',
  'Confirme seus dados'
];

interface Page {
  id: string;
}

const BasicStepper: React.FC = () => {
  const {confirmation} = readDataStorage('success');
  const { idCard, estado } = readDataStorage("home");
  const localStorageCard = readDataStorage("card");
  const { setLoad } = useProgress();
  const { id } = useParams<Page>();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 700);

  const updateIsMobile = () => {
    setIsMobile(window.innerWidth <= 700);
  };

  useEffect(() => {
    window.addEventListener('resize', updateIsMobile);
    return () => {
      window.removeEventListener('resize', updateIsMobile);
    };
  }, []);
  const [activeStep, setActiveStep] = useState<number>(parseInt(id) - 1);

  const [storedValue, setStoredValue] = useState(confirmation);

  const handleValueChange = () => {
    const {confirmation} = readDataStorage('success');
    setStoredValue(confirmation);
  };

 
  const listBanks = useCallback(async () => {
    setLoad(true);
    const stateAbbreviation = getStateAbbreviation(localStorageCard?.Estado);
    await api.get("/csp/banco/listar/"+stateAbbreviation)
      .then((response) => {
        let localBanks = [];
        const {
          data: {
            mensagem: { bancos },
          },
        } = response;
        for (const k in bancos) {
          const { nomBan } = bancos[k];
          localBanks.push({ value: bancos[k], label: nomBan });
        }

        writeStorage({
          'key': 'bancos',
          'object': {
            "bancosStorage":localBanks,
        
            }
        });

        setActiveStep((prevActiveStep) => prevActiveStep - 1);
            const link = '/onboarding/step/'+activeStep  
               if (activeStep === 0){
                 window.location.href ='/onboarding/'; 
              }else{
                window.location.href= link
              }
      })
      .catch((err) => {
        setLoad(false);
        console.error(err);
      });
    setLoad(false);
  }, [setLoad,localStorageCard?.Estado,activeStep]);

  const handleChangeStepperBack = useCallback(async () => {
    setLoad(true);
    await api
      .post(`/csp/proposta/gerar/`, {
        idCard: idCard,
        concessionaria: localStorageCard.Concessionaria,
        estado: estado,
        subClasse: localStorageCard?.Subclasse,
        classe: localStorageCard?.Classe,
        consumo :
        {
           "jan": localStorageCard?.Jan,
           "fev": localStorageCard?.Fev,   
           "mar": localStorageCard?.Mar,    
           "abr": localStorageCard?.Abr,    
           "mai": localStorageCard?.Mai,   
           "jun": localStorageCard?.Jun,    
           "jul": localStorageCard?.Jul,    
           "ago": localStorageCard?.Ago,    
           "set": localStorageCard?.Set,   
           "out": localStorageCard?.Out,   
           "nov": localStorageCard?.Nov,    
           "dez": localStorageCard?.Dez
        }
 
      })
      .then((res) => {
          writeStorage({
            key: "consumo",
            object: {
              arvoresCultivadas: res.data["mensagem"]["arvoresCultivadas"],
              carbonoEvitado: res.data["mensagem"]["carbonoEvitado"],
              economiaVerde: res.data["mensagem"]["economiaVerde"],
              economiaVerdeAno2: res.data["mensagem"]["economiaVerdeAno2"],
              economiaVerdeAno3: res.data["mensagem"]["economiaVerdeAno3"],
              economiaVerdeAno4: res.data["mensagem"]["economiaVerdeAno4"],
              economiaVerdeAno5: res.data["mensagem"]["economiaVerdeAno5"],
              economiaAmarela: res.data["mensagem"]["economiaAmarela"],
              economiaAmarelaAno2: res.data["mensagem"]["economiaAmarelaAno2"],
              economiaAmarelaAno3: res.data["mensagem"]["economiaAmarelaAno3"],
              economiaAmarelaAno4: res.data["mensagem"]["economiaAmarelaAno4"],
              economiaAmarelaAno5: res.data["mensagem"]["economiaAmarelaAno5"],
              economiaVermelhaI: res.data["mensagem"]["economiaVermelhaI"],
              economiaVermelhaIAno2:
                res.data["mensagem"]["economiaVermelhaIAno2"],
              economiaVermelhaIAno3:
                res.data["mensagem"]["economiaVermelhaIAno3"],
              economiaVermelhaIAno4:
                res.data["mensagem"]["economiaVermelhaIAno4"],
              economiaVermelhaIAno5:
                res.data["mensagem"]["economiaVermelhaIAno5"],
              economiaVermelhaII: res.data["mensagem"]["economiaVermelhaII"],
              economiaVermelhaIIAno2:
                res.data["mensagem"]["economiaVermelhaIIAno2"],
              economiaVermelhaIIAno3:
                res.data["mensagem"]["economiaVermelhaIIAno3"],
              economiaVermelhaIIAno4:
                res.data["mensagem"]["economiaVermelhaIIAno4"],
              economiaVermelhaIIAno5:
                res.data["mensagem"]["economiaVermelhaIIAno5"],
              economiaEscassez: res.data["mensagem"]["economiaEscassez"],
              economiaEscassezAno2:
                res.data["mensagem"]["economiaEscassezAno2"],
              economiaEscassezAno3:
                res.data["mensagem"]["economiaEscassezAno3"],
              economiaEscassezAno4:
                res.data["mensagem"]["economiaEscassezAno4"],
              economiaEscassezAno5:
                res.data["mensagem"]["economiaEscassezAno5"],
              kmCarroEletrico: res.data["mensagem"]["kmCarroEletrico"],
              mensalidade: res.data["mensagem"]["mensalidade"],
              concessionaria: res.data["mensagem"]["concessionaria"],
              subClasse: res.data["mensagem"]["subClasse"],
              classe: res.data["mensagem"]["classe"],
              consumoMinimo: res.data["mensagem"]["consumoMinimo"],
              economiaAnual: res.data["mensagem"]["economiaAnual"],
              mediaFinal: res.data["mensagem"]["mediaFinal"],
            },
          });
          setLoad(false);
          setActiveStep((prevActiveStep) => prevActiveStep - 1);
          const link = '/onboarding/step/'+activeStep  
            if (activeStep === 0){
              window.location.href ='/onboarding/'; 
            }else{
              window.location.href= link
            }

      });
    
    setLoad(false);
  }, [
    estado,
    idCard,
    setLoad,
    localStorageCard?.Classe,
    localStorageCard?.Subclasse,
    localStorageCard?.Jan,
    localStorageCard?.Fev,   
    localStorageCard?.Mar,    
    localStorageCard?.Abr,    
    localStorageCard?.Mai,   
    localStorageCard?.Jun,    
    localStorageCard?.Jul,    
    localStorageCard?.Ago,    
    localStorageCard?.Set,   
    localStorageCard?.Out,   
    localStorageCard?.Nov,    
    localStorageCard?.Dez,
    activeStep,
    localStorageCard.Concessionaria
  ]);
  const handleBack = () => {

    if (activeStep === 2){
      handleChangeStepperBack()
    }
    if (activeStep === 3){
      listBanks()
    }
    if (activeStep < 3){
      setLoad(true);
      api.get('/csp/cliente/consultar/card/'+idCard).then((res: any) => {
        if (res.status === 200) {
          writeStorage({
            'key': 'card',
            'object': {
              "NomeTitularConta":res.data["empresa"],
              "OndeEconomizar":res.data["onde_voc_quer_economizar"],
              "Pessoa":res.data["tipo"],
              "CNPJrepresentante":res.data["cnpj_do_representante_1"],
              "Estado": res.data["estado"],
              "Cidade": res.data["cidade"],
              "Bairro": res.data["bairro"],
              "Rua": res.data["rua"],
              "Numero": res.data["n_mero"],
              "Complemento": res.data["complemento"],
              "Classe":res.data["classe"],
              "Subclasse":res.data["subclasse"],
              "Jan":res.data["jan"],
              "Fev":res.data["fev"],
              "Mar":res.data["mar"],
              "Abr":res.data["abr"],
              "Mai":res.data["mai"],
              "Jun":res.data["jun"],
              "Jul":res.data["jul"],
              "Ago":res.data["ago"],
              "Set":res.data["set"],
              "Out":res.data["out"],
              "Nov":res.data["nov"],
              "Dez":res.data["dez"],
              "MediaConsumo":res.data["m_dia_de_consumo"],
              "FormaPagamento":res.data["forma_de_pagamento"],
              "CEPvalidoCard": 1,
              "RazaoSocialCard":res.data["raz_o_social"],
              "Email":res.data["email"],
              "EmailDoResponsavel":res.data["email_do_respons_vel_legal"],
              "TelefoneTitularConta":res.data["telefone_do_titular_da_conta"],
              "TelefoneResponsavelLegal":res.data["telefone_do_respons_vel_legal"],
              "cpfCnpjCard":res.data["tipo"] === "PJ" ? res.data["cnpj"] : res.data["cpf"],
              "DataNascimentoTitular":res.data["data_de_nascimento_do_titular"]?.split(" ")[0].split("/").reverse().join('-'),
              "NomeResponsavelLegal":res.data["nome_do_respons_vel_legal"],
              "CPF":res.data["tipo"]=== "PF" ? res.data["cpf"] : res.data["cpf_do_respons_vel_legal"],
              "CEP":res.data["cep"],
              "NumeroInstalacao": res.data["n_mero_da_instala_o_cemig_1"],
              "DataVencimentoFatura":res.data["data_de_vencimento_da_fatura_cemig"],
              "Banco":res.data["banco"],
              "CodBanco":res.data["codban"],
              "Agencia":res.data["ag_ncia"],
              "Conta":res.data["conta"],
              "OptanteSimples":res.data["empresa_optante_pelo_simples"],
              "Concessionaria":res.data["concession_ria"],
              "TelefoneLigacao":res.data["telefone_contato_para_liga_o"]
              }
          });
          setLoad(false);
        handleChangeStepperBack()
      }
      })
    }
    };

//StepperMobile
const ColorlibConnectorMobile = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 14,
  },
  [`&.${stepConnectorClasses.root}`]: {
    left: 'calc(-60% + 20px)',
    right: 'calc(40% + 20px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor:'#6C5AF4',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor:'#6C5AF4',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderRadius: 1,
  },
}));

const ColorlibStepIconMobile = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: '#E0E0E0',
  zIndex: 1,
  color: '#fff',
  width: 30,
  height: 30,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize:"16px",
  fontFamily: 'Open Sans, sans-serif',
  ...(ownerState.active && {
    backgroundColor:'#6C5AF4',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  }),
  ...(ownerState.completed && {
    backgroundColor:'#6C5AF4',
  }),
}));




const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor:'#6C5AF4',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor:'#6C5AF4',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled('div')<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor: '#E0E0E0',
  zIndex: 1,
  color: '#fff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize:"22px",
  fontFamily: 'Open Sans, sans-serif',
  ...(ownerState.active && {
    backgroundColor:'#6C5AF4',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  }),
  ...(ownerState.completed && {
    backgroundColor:'#6C5AF4',
  }),
}));

function ColorlibStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;

  const icons: { [index: string]: React.ReactElement } = {
    1: <p>1</p>,
    2: <p>2</p>,
    3: <p>3</p>,
    4: <p>4</p>,
  };

  return (
    <>
    {isMobile ? (
      <ColorlibStepIconMobile ownerState={{ completed, active }} className={props.className}>
        {icons[String(props.icon)]}
      </ColorlibStepIconMobile>
    ) : (
      <ColorlibStepIconRoot ownerState={{ completed, active }} className={props.className}>
        {icons[String(props.icon)]}
      </ColorlibStepIconRoot>
    )}
  </>
  );
}



  const renderSwitch = (key: number) => {
     switch(key) {
       case 0: 
         return <UserConsumption />
       case 1: 
         return <GridGrafico />
       case 2: 
         return <Holderdata />
       case 3:
         return <HolderConfirmation />
       default: 
        return <UserConsumption />  
     }
  }
console.log(confirmation)

  return (

    <>
    <ValueChangeWatcher onValueChange={handleValueChange} />
    <ButtonStep style={confirmation === true ? {display: 'none' } : {}} onClick={handleBack}>
    <button className='ButtonStep' id="btnStepper">
    <img src={SetaButton}  alt='img'/>Voltar</button></ButtonStep>
    <ContainerSection>
      <StepperStyleDesktop>
        <Box>
          <Stack sx={{  marginLeft:'auto', marginRight:'auto' }} spacing={4}>
            <Stepper alternativeLabel activeStep={activeStep} connector={isMobile ? <ColorlibConnectorMobile /> : <ColorlibConnector />}>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel StepIconComponent={ColorlibStepIcon}><StepperStyleLabel>{label}</StepperStyleLabel></StepLabel>
                </Step>
              ))}
            </Stepper>
          </Stack>
        </Box>
        {renderSwitch(activeStep)}
      </StepperStyleDesktop>


    </ContainerSection></>
);
  
}


export default BasicStepper;